import { Notify } from 'quasar';
import { sentry } from './sentry.ts';

class ErrorHandler {
  error: Error;
  showNotification: boolean;
  customMessage: string;

  constructor(error: Error, showNotification: boolean = true, customMessage: string = '') {
    this.error = error;
    this.showNotification = showNotification;
    this.customMessage = customMessage;
  }

  handleError() {
    sentry().sendError(this.error);
    if (this.showNotification) {
      Notify.create({
        message: this.customMessage || this.error.message,
        color: 'negative',
        icon: 'report_problem',
        position: 'top-right',
      });
    }
  }
}

export default ErrorHandler;
